<template lang="pug">
  div(class='')
    app-header(:white='true' class='u-bg-primary')

    div(class='u-bg-white o-container u-py4')
      h2(class='u-center u-fz-h1 u-line-1 u-my3')
        span(class='u-fw-light') Entérate sobre&nbsp;
        strong(class='u-color-secondary') nuestras actividades

    div(class="u-bg-border")
      div(class='o-wrapper u-pt5 u-flex' id='posts-container')
        section(class='u-mb4 u-flex-1')
          article(v-for='post in posts' class='c-post u-mb4' data-aos='fade-up' )
            progressive-background(:src='post.imageUrl' class='c-post__image', :placeholder='post.imageThumbUrl')
            div(class='u-p4')
              router-link(:to="{ name: 'Post', params:{slug: post.slug}}" class='c-post__title u-fz-h3') {{post.title}}
              div(v-html='post.content')
              p(class='')
                router-link(:to="{ name: 'Post', params:{slug: post.slug}}" class='u-color-secondary') Leer más...
              p(class='u-mb0 u-right-align u-capitalize u-color-dark u-fw-s-bold') {{post.date}}

          nav(class='u-flex u-justify-between u-items-center' v-if='posts.length > 0 && totalPages != 1')
            button(class="c-btn c-btn--tertiary u-p2 u-fz-h4", :disabled='currentPage === 1' @click="prevPosts" v-scroll-to="'#posts-container'")
              i(class='u-icon') arrow_left
            ul(class='u-flex u-mt0 u-mb0 u-px2 u-flex-wrap' v-if='totalPages > 0')
              li(class='u-px1' v-for='number in totalPages')
                button(@click="changePage(number)" v-scroll-to="'#posts-container'" class="u-fw-s-bold u-px1", :class="{'u-color-primary' : currentPage === number}")  {{number}}
            button(class="c-btn c-btn--tertiary u-p2 u-fz-h4", :disabled='totalPages === currentPage' @click="nextPosts" v-scroll-to="'#posts-container'")
              i(class='u-icon') arrow_right

        aside(class='u-mb5 u-ml5 u-show@tablet')
          p(class='u-uppercase u-color-dark u-fw-s-bold' data-aos='fade-up' ) Síguenos
          ul(class='u-m0 u-px4 u-py3 u-list-none u-bg-white u-mb4' data-aos='fade-up' )
            li()
              a(:href='company.facebookPage' target='_blank' class='u-flex  u-items-center u-decoration-none')
                span(class='c-btn-share c-btn-share--facebook')
                  i(class='u-icon') facebook
                span {{company.name}}
            //- li(class='u-my3')
            //-   a(:href='company.linkedinPage' target='_blank' class='u-flex  u-items-center u-decoration-none')
            //-     span(class='c-btn-share c-btn-share--linkedin')
            //-       i(class='u-icon') linkedin
            //-     span {{company.name}}
            //- li
            //-   a(:href='company.instagramPage' target='_blank' class='u-flex  u-items-center u-decoration-none')
            //-     span(class='c-btn-share c-btn-share--instagram')
            //-       i(class='u-icon') instagram
            //-     span {{company.name}}
          iframe(data-aos='fade-up'  class='u-mx-auto u-block u-facebook', :src="faceWeb" width="320" height="400" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true")

    app-footer
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'PostsScreen',
    data () {
      return {
        posts: [],
        isLoading: false,
        currentPage: 1,
        totalPages: 1,
        lastPage: 1
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      }),

      faceWeb () {
        return `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(this.company.facebookPage)}&tabs=timeline&width=320&height=400&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
        // return `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent('https://www.facebook.com/NoveltiePeru/')}&tabs=timeline&width=320&height=400&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
      }
    },

    methods: {
      prevPosts () {
        if (this.currentPage > 1) {
          this.currentPage -= 1
          this.getPosts()
        }
      },

      nextPosts () {
        if (this.currentPage < this.totalPages) {
          this.currentPage += 1
          this.getPosts()
        }
      },

      changePage (page) {
        this.currentPage = page
        this.getPosts()
      },

      getPosts () {
        axios.get(`${window.API_URL}/posts?page=${this.currentPage}`)
          .then(({data}) => {
            this.posts = data.data
            this.totalPages = data.last_page
            this.isLoading = false
          })
      }
    },

    created () {
      this.getPosts()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Posts/components/PostsScreen.vue